export default {
    name: 'soilComposition',
    serverName: '​/api/v1/rb_calculator/mechanical_composition_of_soil/',
    apiUrl: '/api/v1/rb_calculator/mechanical_composition_of_soil/'
};
